import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-name',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-name.component.html',
  styleUrl: './app-name.component.scss'
})
export class AppNameComponent {
  @Input() size: 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' = 'xl';
  @Input() weight: 'normal' | 'medium' | 'semibold' | 'bold' = 'bold';

  get sizeClass(): string {
    return `text-${this.size}`;
  }

  get weightClass(): string {
    return `font-${this.weight}`;
  }
}